import { render, staticRenderFns } from "./Essay.vue?vue&type=template&id=652df5d7&scoped=true&"
import script from "./Essay.vue?vue&type=script&lang=js&"
export * from "./Essay.vue?vue&type=script&lang=js&"
import style0 from "./Essay.vue?vue&type=style&index=0&id=652df5d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652df5d7",
  null
  
)

export default component.exports